export default {"frames": [

{
	"filename": "01_furious.png",
	"frame": {"x":480,"y":1236,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "02_sad.png",
	"frame": {"x":487,"y":622,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "03_angry.png",
	"frame": {"x":537,"y":1,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "04_agitated.png",
	"frame": {"x":861,"y":1196,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "05_confused.png",
	"frame": {"x":1,"y":1,"w":534,"h":619},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":214,"y":223,"w":534,"h":619},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "06_amused.png",
	"frame": {"x":868,"y":575,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "07_mildly-happy.png",
	"frame": {"x":918,"y":1,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "08_happy.png",
	"frame": {"x":1242,"y":1149,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "09_ecstatic.png",
	"frame": {"x":1249,"y":575,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bust.png",
	"frame": {"x":1,"y":622,"w":484,"h":612},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":264,"y":213,"w":484,"h":612},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "confused_face.png",
	"frame": {"x":1,"y":1236,"w":477,"h":575},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":184,"y":271,"w":477,"h":575},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "error.png",
	"frame": {"x":1623,"y":1149,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "furious_cheeks.png",
	"frame": {"x":1,"y":1813,"w":269,"h":169},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":385,"y":344,"w":269,"h":169},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "headphones.png",
	"frame": {"x":1242,"y":1723,"w":358,"h":299},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":331,"y":158,"w":358,"h":299},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "idle_bored.png",
	"frame": {"x":1630,"y":575,"w":293,"h":564},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":390,"y":261,"w":293,"h":564},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "idle_ready.png",
	"frame": {"x":1299,"y":1,"w":379,"h":572},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":265,"y":253,"w":379,"h":572},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "loading.png",
	"frame": {"x":1680,"y":1,"w":293,"h":564},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":390,"y":261,"w":293,"h":564},
	"sourceSize": {"w":1024,"h":1024}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "faces.png",
	"format": "RGBA8888",
	"size": {"w":2048,"h":2048},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:92ce313e512814937a261e6241fb0d2c:2bad2295cfb49cfa858c814515534d9b:7cf197594d1a3722e0018a2f0a0b0770$"
}
}
